import React, { useEffect } from 'react';

import {
  CmAlert,
  CmBox,
  CmButton,
  CmFormErrorMessage,
  CmLabelAndPasswordInput,
  CmModal,
  CmStack,
} from '@/components/uiParts';

import { useChangePasswordDialog } from './useChangePasswordDialog';

type Props = {
  id: string;
  authStoreId: number;
  isModalOpen: boolean;
  setIsModalOpen: (x: boolean) => void;
};

export const ChangePasswordDialog: React.FC<Props> = ({
  id,
  authStoreId,
  isModalOpen,
  setIsModalOpen,
}) => {
  const {
    // flags
    isPending,
    isShowNewPassword,
    isShowNewConfirmPassword,
    isPasswordsUnmatched,
    isNewPasswordEmpty,
    isNewConfirmPasswordEmpty,
    // errors
    requestError,
    newPasswordInvalidError,
    // refs
    newRef,
    newConfirmRef,
    // event handlers
    handleShowNewPassword,
    handleShowNewConfirmPassword,
    handleOnBlurNewPasswords,
    handleSubmit,
    handleCancel,
  } = useChangePasswordDialog(authStoreId, setIsModalOpen);

  useEffect(() => {
    if (isModalOpen) {
      setTimeout(() => {
        newRef.current?.focus();
      }, 0);
    }
  }, [isModalOpen]);

  return (
    <CmModal
      key={`${id}-change-form`}
      id={`${id}-change-form`}
      size="lg"
      headerSize="sm"
      showCloseButton
      isCentered
      isOpen={isModalOpen}
      onClose={handleCancel}
      title="パスワード変更"
    >
      <CmStack paddingX={6} paddingBottom={4}>
        {requestError && (
          <CmAlert status="error">
            パスワードの変更に失敗しました: {requestError}
          </CmAlert>
        )}
        <CmBox py={4} my={4}>
          <CmLabelAndPasswordInput
            ref={newRef}
            label="新しいパスワード"
            isShow={isShowNewPassword}
            isRequired
            isInvalid={isNewPasswordEmpty || !!newPasswordInvalidError}
            handleShowPassword={handleShowNewPassword}
            onBlur={handleOnBlurNewPasswords}
          >
            {isNewPasswordEmpty && (
              <CmFormErrorMessage>
                新しいパスワードを入力してください
              </CmFormErrorMessage>
            )}
            {!!newPasswordInvalidError && (
              <CmFormErrorMessage>{newPasswordInvalidError}</CmFormErrorMessage>
            )}
          </CmLabelAndPasswordInput>
          <CmLabelAndPasswordInput
            ref={newConfirmRef}
            label="新しいパスワード（確認）"
            isShow={isShowNewConfirmPassword}
            isRequired
            isInvalid={isPasswordsUnmatched || isNewConfirmPasswordEmpty}
            handleShowPassword={handleShowNewConfirmPassword}
            onBlur={handleOnBlurNewPasswords}
          >
            {isNewConfirmPasswordEmpty && (
              <CmFormErrorMessage>
                新しいパスワード（確認）を入力してください
              </CmFormErrorMessage>
            )}
            {isPasswordsUnmatched && (
              <CmFormErrorMessage>
                新しいパスワードと新しいパスワード（確認）が一致しません
              </CmFormErrorMessage>
            )}
          </CmLabelAndPasswordInput>
        </CmBox>
        <CmStack isInline justifyContent={'space-between'}>
          {/** @ts-ignore TS2590 **/}
          <CmButton onClick={handleSubmit} disabled={isPending}>
            パスワード変更
          </CmButton>
          <CmButton variant="outline" onClick={handleCancel}>
            キャンセル
          </CmButton>
        </CmStack>
      </CmStack>
    </CmModal>
  );
};
